export default {"src":"/_next/static/media/delete.03ef8df0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};